import { render } from "./UserApplication.vue?vue&type=template&id=2dc210ca"
import script from "./UserApplication.vue?vue&type=script&lang=js"
export * from "./UserApplication.vue?vue&type=script&lang=js"

import exportComponent from "/home/builder/shared-storage/.project-directory/login-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__